import { z } from "zod";

import type { Field } from "./types";

const fieldTypeToZodTypes: Record<Field["type"], string[]> = {
  text: ["string"],
  number: ["number", "bigint"],
  boolean: ["boolean"],
  date: ["date"],
  select: ["enum", "nativeEnum", "literal"],
  array: ["array"],
  object: ["object"],
};

const typeMap = Object.fromEntries(
  Object.entries(fieldTypeToZodTypes).flatMap(([fieldType, zodTypes]) =>
    zodTypes.map((z) => [z, fieldType]),
  ),
) as Record<string, Field["type"]>;

export function unwrapZodType(schema: z.ZodTypeAny): z.ZodTypeAny {
  if (schema instanceof z.ZodOptional || schema instanceof z.ZodNullable) {
    return unwrapZodType(schema.def.innerType as z.ZodTypeAny);
  }

  if (schema instanceof z.ZodDefault) {
    return unwrapZodType(schema.def.innerType as z.ZodTypeAny);
  }

  return schema;
}

export function getSchemaFieldType(schema: z.ZodTypeAny): Field["type"] {
  const unwrapped = unwrapZodType(schema);

  return typeMap[unwrapped.def.type] ?? "text";
}

// Extract enum options from a ZodEnum
export function getEnumOptions(schema: z.ZodTypeAny): readonly string[] | null {
  const unwrapped = unwrapZodType(schema);

  if (unwrapped instanceof z.ZodEnum) {
    return unwrapped.options as readonly string[];
  }

  return null;
}
